import { render, staticRenderFns } from "./TaxonomyCrud.vue?vue&type=template&id=05a4f3f1&"
import script from "./TaxonomyCrud.vue?vue&type=script&lang=js&"
export * from "./TaxonomyCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports